import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button-fill',
  templateUrl: './button-fill.component.html',
  styleUrls: ['./button-fill.component.scss']
})
export class ButtonFillComponent {
  @Input() buttonText: string = '';
  @Input() action: (() => void)  = ()=>{};
  @Input() loading: boolean | undefined;
  @Input() processLoading: boolean = false;
}
